import React from "react"
import { NextSeo } from "next-seo"

import Layout from "~/components/Pages/Basic"
import Markdown from "~/components/Markdown"
import PrivacyPolicyMarkdown from "~/content/privacyPolicy.md"

const PrivacyPolicyPage = () => {
  return (
    <>
      <NextSeo
        title="Privacy Policy | WinIt"
        description="Learn how WinIt protects your privacy and handles your personal information when you use our app and services."
        canonical="https://www.appwinit.com/privacy-policy"
        additionalMetaTags={[
          {
            property: "description",
            content:
              "Learn how WinIt protects your privacy and handles your personal information when you use our app and services.",
          },
        ]}
      />
      <Layout>
        <Markdown src={PrivacyPolicyMarkdown} />
      </Layout>
    </>
  )
}

export default PrivacyPolicyPage
